export default __webpack_public_path__ + "static/media/Email.f7974100.jpg";